import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/transfers'

const transfersEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchTransfers: builder.query<any, { pageNumber?: number; pageSize?: number }>({
    query: ({ pageNumber = 0, pageSize = 10 } = {}) => ({
      url: `${basePath}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      method: 'get',
    }),
    providesTags: ['transfers'],
  }),

  createTransfer: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['transfers', 'running-dashboard'],
  }),

  deleteTransfer: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['transfers', 'running-dashboard'],
  }),

  fetchTransferFeesReport: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${basePath}/fees-report?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
    providesTags: ['transfers'],
  }),
})

export default transfersEndpoints
